import { Check, MailOutline } from "@material-ui/icons";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/Commission/create.js";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import { masterApi } from "functions/apis";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select
} from "@material-ui/core";
import PropTypes from "prop-types";
import Datetime from "react-datetime";
import { coreApi } from "functions/apis";
import moment from "moment";
import { tripDateFormat } from "functions/Helper";
import { bookingApi } from "functions/apis";

const useStyles = makeStyles(styles);

const defaultState = {
  date: null,
  hasRouteRestriction: false,
  routeID: null,
  hasTimeRestriction: false,
  time: null
};

export default function CreatePeakHourTrips(props) {
  const [redirect, setRedirect] = useState(false);
  const [routeList, setRouteList] = useState([]);
  const [selectedSectorID, setSelectedSectorID] = useState();
  const [sectorList, setSectorList] = useState([]);
  const [timeList, setTimeList] = useState([]);
  const [state, setState] = useState({ ...defaultState });
  const [disabled, setDisabled] = React.useState(false);

  const cretePeakSignal = React.useRef(new AbortController());

  const getSector = () => {
    masterApi
      .get("/Sectors", {
        signal: cretePeakSignal.current.signal,
        params: {
          pagination: {
            pageIndex: 0,
            pageSize: 0
          },
          filter: {
            searchString: null,
            publicationStatus: 1
          }
        }
      })
      .then(data => setSectorList(data.records))
      .catch(error => console.log(error));
  };

  const getRoutes = () => {
    masterApi
      .get("/Routes", {
        signal: cretePeakSignal.current.signal,
        params: {
          pagination: {
            pageIndex: 0,
            pageSize: 0
          },
          filter: {
            searchString: null,
            publicationStatus: 1,
            sectorID: selectedSectorID
          }
        }
      })
      .then(data => setRouteList(data.records))
      .catch(error => console.log(error));
  };

  useEffect(() => {
    getSector();
    return () => {
      cretePeakSignal.current.abort();
    };
  }, []);

  useEffect(() => {
    getRoutes();
  }, [selectedSectorID]);

  useEffect(() => {
    if (state.routeID !== null && state.date !== null) {
      let selectedRoute = routeList.find(r => r.id === state.routeID);
      let ports = selectedRoute.code.split(" - ");
      let embarkationPort = ports[0];
      let destinationPort = ports[1];
      if (embarkationPort === "TMFT") embarkationPort = "TMF";
      if (destinationPort === "TMFT") destinationPort = "TMF";
      coreApi
        .get("/Trips", {
          signal: cretePeakSignal.current.signal,
          params: {
            embarkation: embarkationPort,
            destination: destinationPort,
            tripDate: moment(state.date).format("yyyyMMDD"),
            status: "active"
          }
        })
        .then(data => setTimeList(data.data))
        .catch(error => {
          console.log(error);
          setTimeList([]);
        });
    } else {
      setTimeList([]);
    }
  }, [selectedSectorID, state.date]);

  const handleSelectedSectorIDChanged = e =>
    setSelectedSectorID(e.target.value);

  const handleRouteIDChanged = e =>
    setState({ ...state, routeID: e.target.value });

  const handleHasRouteRestrictionChanged = e =>
    setState({ ...state, hasRouteRestriction: e.target.checked });

  const handleHasTimeRestrictionChanged = e =>
    setState({ ...state, hasTimeRestriction: e.target.checked });

  const handleSubmit = () => {
    setDisabled(true);
    bookingApi
      .post("/PeakHourTrips", state, {
        signal: cretePeakSignal.current.signal
      })
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  const classes = useStyles();

  return redirect ? (
    <Redirect to={"/admin/PeakHourTripsList/InDraft"} />
  ) : (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>CREATE PEAK HOUR TRIP</h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <GridContainer>
              <GridItem xs={12} md={12}>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <InputLabel
                    htmlFor="selSector"
                    className={classes.selectLabel}
                  >
                    Sector
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    classes={{
                      select: classes.select
                    }}
                    value={selectedSectorID ?? ""}
                    onChange={handleSelectedSectorIDChanged}
                  >
                    {sectorList.map(record => {
                      return (
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value={record.id}
                          key={record.id}
                        >
                          <b>{record.code}</b>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={12}>
                <InputLabel className={classes.selectLabel}>
                  Departure Date
                </InputLabel>
                <FormControl fullWidth>
                  <Datetime
                    value={state.date}
                    onChange={e =>
                      setState({
                        ...state,
                        date: e === "" ? null : e,
                        time: null
                      })
                    }
                    dateFormat={tripDateFormat}
                    timeFormat={false}
                    utc={true}
                    closeOnSelect={true}
                    inputProps={{
                      placeholder: "Date"
                    }}
                  />
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={state.hasRouteRestriction}
                      onChange={handleHasRouteRestrictionChanged}
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      classes={{
                        checked: classes.checked,
                        root: classes.checkRoot
                      }}
                    />
                  }
                  classes={{
                    label: classes.label,
                    root: classes.labelRoot
                  }}
                  label="Has Route Restriction"
                />
              </GridItem>
              {state.hasRouteRestriction && (
                <GridItem xs={12} md={6}>
                  <FormControl fullWidth className={classes.selectFormControl}>
                    <InputLabel
                      htmlFor="selRoute"
                      className={classes.selectLabel}
                    >
                      Route
                    </InputLabel>
                    <Select
                      MenuProps={{
                        className: classes.selectMenu
                      }}
                      classes={{
                        select: classes.select
                      }}
                      value={state.routeID ?? ""}
                      onChange={handleRouteIDChanged}
                    >
                      {routeList.map(record => {
                        return (
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected
                            }}
                            value={record.id}
                            key={record.id}
                          >
                            <b>{record.code}</b>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              <GridItem xs={12} md={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={state.hasTimeRestriction}
                      onChange={handleHasTimeRestrictionChanged}
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      classes={{
                        checked: classes.checked,
                        root: classes.checkRoot
                      }}
                    />
                  }
                  classes={{
                    label: classes.label,
                    root: classes.labelRoot
                  }}
                  label="Has Time Restriction"
                />
              </GridItem>
              {state.hasTimeRestriction && (
                <GridItem xs={12} md={6}>
                  <FormControl fullWidth className={classes.selectFormControl}>
                    <InputLabel
                      htmlFor="selTime"
                      className={classes.selectLabel}
                    >
                      Time
                    </InputLabel>
                    <Select
                      MenuProps={{
                        className: classes.selectMenu
                      }}
                      classes={{
                        select: classes.select
                      }}
                      value={state.time ?? ""}
                      onChange={e =>
                        setState({ ...state, time: e.target.value })
                      }
                    >
                      {timeList.map(record => {
                        return (
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected
                            }}
                            value={record.tripTime}
                            key={record.tripTime}
                          >
                            <b>{`${record.tripTime.substring(
                              0,
                              2
                            )}:${record.tripTime.substring(2, 4)}`}</b>{" "}
                            {record.timezoneLabel}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              <GridItem xs={12} md={12}>
                <Button
                  disabled={disabled}
                  color="rose"
                  type="submit"
                  value="Submit"
                  onClick={() => handleSubmit()}
                >
                  Submit
                </Button>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

CreatePeakHourTrips.propTypes = {
  history: PropTypes.object
};
